import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const BarChartHBStatistics = ({HBTestPassData}) => {

  const graphData = [
    ["TCU Data", HBTestPassData?.avgTcuAvailabilityPercentage || 0],
    ["Battery Data", HBTestPassData?.avgBatteryAvailabilityPercentage || 0],
    ["Accelerometer Data", HBTestPassData?.avgAccelerometerAvailabilityPercentage || 0],
    ["Analog Data", HBTestPassData?.avgAnalogAvailabilityPercentage || 0],
    ["Motor Data", HBTestPassData?.avgMotorAvailabilityPercentage || 0],
    ["Location Data", HBTestPassData?.avgLocationAvailabilityPercentage || 0]
  ];

  const getOptions = {
    chart: {
      type: "bar",
      height: 320,
    },
    title: {
      text: "",
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      valueSuffix: " %",
    },
    
    plotOptions: {
      bar: {
        borderRadius: '20%',
        dataLabels: {
            enabled: true
        },
        groupPadding: 0.1,
      }
    },
    series: [
      {
        dataLabels: {
          enabled: true,
          verticalAlign: "middle",
          format: "{point.y:.1f}%",
          style: {
            fontSize: "13px",
            fontFamily: "Verdana, sans-serif",
          },
        },
        size: "95%",
        data: graphData,
        color: {
          linearGradient: [40, '90%', 50, '80%'],
            stops: [
              [0, '#3274D9'],
              [1, '#A354CC']
            ]
        }
      },
    ],
    credits: {
      enabled: false,
    },
    xAxis: {
      type: "category",
      gridLineWidth: 0,
    },
    yAxis: {
      title: {
        text: "",
      },
      min: 0,
      max: 100,
      gridLineWidth: 0,
      labels: {
        format: '{value}%'
      },
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={getOptions} />
    </div>
  )
};

export default BarChartHBStatistics;
